export class Thread {

  public static sleep (delay) {
    return new Promise(resolve => setTimeout(resolve, delay || 0))
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/utils/thread.ts